import { scoreTriggerCodec } from '@/services/api/resources/scoreTrigger';
import * as t from 'io-ts';
import { id } from '@/services/api';

export const checklistNotifiableCodec = t.type({
  id,
  entityItemSpecificAssignments: t.boolean,
  users: t.array(t.number),
  externalAssociates: t.array(t.type({
    id,
    email: t.string,
  })),
  scoreTrigger: t.union([scoreTriggerCodec, t.null]),
});

export const checklistNotifiableListCodec = t.type({
  data: t.array(checklistNotifiableCodec),
});
